__turbopack_context__.v({
  "bannerCta": "XMv9gW_bannerCta",
  "content": "XMv9gW_content",
  "locationLabel": "XMv9gW_locationLabel",
  "title": "XMv9gW_title",
});
